<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model class="search-form">
      <a-form-model-item>
        <span style="margin-right: 8px">时间:</span>
        <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" />
      </a-form-model-item>
      <a-form-model-item>
        <span style="margin-right: 8px">团队:</span>
        <a-checkable-tag :checked="selectedTeams.length === 0" @change="selectedTeams = []">全部</a-checkable-tag>
        <a-checkable-tag v-for="(team, index) in teams" :key="index" :checked="selectedTeams.indexOf(team.id) > -1" @change="checked => handleChange(team.id, checked)">
          {{ team.name }}
        </a-checkable-tag>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';
import { diagramList } from '@/api/system/team';

export default {
  name: 'DataFilter',
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      labelCol: { span: 1 },
      wrapperCol: {},
      checkAll: true,
      indeterminate: false,
      plainOptions: [],
      teams: [],
      selectedTeams: []
    };
  },

  computed: {
    filter() {
      const { checkedDate, selectedTeams } = this;
      return {
        checkedDate,
        selectedTeams
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate, this.selectedTeams);
    }
  },
  created() {
    this.getTeamList();
    this.$emit('change', this.checkedDate, this.selectedTeams);
  },

  methods: {
    handleChange(team_id, checked) {
      const { selectedTeams } = this;
      const nextSelectedTeams = checked ? [...selectedTeams, team_id] : selectedTeams.filter(t => t !== team_id);
      this.selectedTeams = nextSelectedTeams;
    },
    // 获取团队列表
    getTeamList() {
      diagramList({ category: 1 }).then(res => {
        this.teams = res.data.items;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
